import React from 'react';
import { Link } from 'react-router-dom';

const ModuleFooterNav = ({ moduleId, totalModules }) => {
  const isFirst = moduleId === 1;
  const isLast = moduleId === totalModules;

  return (
    <nav
      aria-label="Module navigation"
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '10px',
        marginTop: '30px',
        paddingTop: '20px',
        borderTop: '1px solid #ddd'
      }}
    >
      <div>
        {!isFirst && (
          <Link to={`/induction/module/${moduleId - 1}`}>&larr; Previous</Link>
        )}
      </div>
      <div>
        <Link to="/induction">Back to course overview</Link>
      </div>
      <div>
        {isLast ? (
          <Link to="/induction/assessment" className="external-link-btn">Start the assessment &rarr;</Link>
        ) : (
          <Link to={`/induction/module/${moduleId + 1}`}>Next &rarr;</Link>
        )}
      </div>
    </nav>
  );
};

export default ModuleFooterNav;
